import { render, staticRenderFns } from "./ProductBatchPriceTable.vue?vue&type=template&id=63234694&"
import script from "./ProductBatchPriceTable.vue?vue&type=script&lang=js&"
export * from "./ProductBatchPriceTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductBatchPriceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports